import Typography, { TypographyProps } from 'components/core/Typography'
import { useEffect, useMemo, useState, memo } from 'react'
import { formatDateTimeRangeString } from 'utils/date.utils'
import { Tooltip } from 'components/core/Tooltip'
import { formatChatMessageDateTime } from 'utils/chat.utils'

const MINUTE = 1000 * 60
const HOUR = MINUTE * 60
export const DynamicChatTimestamp = memo(
    ({
        dateTime,
        variant = 'caption',
        color = 'secondary',
    }: {
        dateTime?: string
        variant?: TypographyProps['variant']
        color?: TypographyProps['color']
    }) => {
        const ts = useMemo(() => {
            if (typeof dateTime === 'string' && !isNaN(Date.parse(dateTime))) {
                return dateTime
            }
            return new Date().toISOString()
        }, [dateTime])

        const [shortTs, setShortTs] = useState(() =>
            formatChatMessageDateTime(ts)
        )

        const fullTs = useMemo(
            () => formatDateTimeRangeString({ from: ts, hasTime: true }),
            [ts]
        )

        useEffect(() => {
            // If the ts in the last hour, update every minute.
            if (new Date(ts).getTime() > Date.now() - HOUR) {
                const intervalId = setInterval(() => {
                    setShortTs(formatChatMessageDateTime(ts))
                }, 1000 * 60)
                return () => {
                    clearInterval(intervalId)
                }
            }
        }, [ts])

        return (
            <Tooltip content={fullTs}>
                <div>
                    <Typography variant={variant} color={color}>
                        {shortTs}
                    </Typography>
                </div>
            </Tooltip>
        )
    }
)
